export const SPECIAL_VALIDATION_EMAILS = [
  "yawar@nomadstrategies.ca",
  "adeel@nomadstrategies.ca"
];
